import { render, staticRenderFns } from "./ChannelFee.vue?vue&type=template&id=235b1b46&scoped=true"
import script from "./ChannelFee.vue?vue&type=script&lang=js"
export * from "./ChannelFee.vue?vue&type=script&lang=js"
import style0 from "./ChannelFee.vue?vue&type=style&index=0&id=235b1b46&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235b1b46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('235b1b46')) {
      api.createRecord('235b1b46', component.options)
    } else {
      api.reload('235b1b46', component.options)
    }
    module.hot.accept("./ChannelFee.vue?vue&type=template&id=235b1b46&scoped=true", function () {
      api.rerender('235b1b46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/ezpay/components/MessageManage/ChannelFee.vue"
export default component.exports